import { TextField, Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';

import Modal from '../../../../components/Modal';

function NewMapping({
  openAddModal,
  handleModalClose,
  language,
  colourNameForNewMapping,
  setColourNameForNewMapping,
  addColourDetails,
  mainEnglishColoursName,
  englishSwatchColoursName,
  setSelectedColourNameForNewMapping,
  selectedColourNameForNewMapping,
  translatedSwatchColoursName,
  langName,
}) {
  const isEnglish = language === 1;
  const mainColours = (isEnglish && mainEnglishColoursName !== undefined) ? mainEnglishColoursName.map((x) => x.SwatchColour1) : [];
  const englishSwatchColours = (englishSwatchColoursName !== undefined) ? englishSwatchColoursName : [];
  const mainNonEnglishColours = (!isEnglish && translatedSwatchColoursName !== undefined) ? translatedSwatchColoursName : [];

  return (
    <Modal
      open={openAddModal}
      onClose={handleModalClose}
      title="Add New Mapping"
      containerWidth="xs"
      titleVariant="h4"
      desktopModalWidth="35%"
      desktopModalHeight="51vh"
      buttonLabel="ADD"
      buttonOnClick={addColourDetails}
      buttonColour="primary"
      roundedButton
      disableButton={!colourNameForNewMapping || !selectedColourNameForNewMapping}
    >
      <div className="flex flex-col p-8">
        <div className="mb-3">
          {isEnglish
            ? (
              <div className="flex flex-col -mt-5">
                <Autocomplete
                  size="large"
                  disablePortal
                  options={isEnglish ? mainColours : englishSwatchColours}
                  sx={{ width: 300, ml: 1, mb: 2 }}
                  inputValue={selectedColourNameForNewMapping}
                  onInputChange={(event, newInputValue) => {
                    setSelectedColourNameForNewMapping(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        !isEnglish
                          ? 'Swatch Colours' : 'Main Colours'
                      }
                      variant="outlined"
                    />
                  )}
                />
                <Autocomplete
                  size="large"
                  disablePortal
                  freeSolo
                  options={isEnglish ? englishSwatchColours : mainNonEnglishColours}
                  sx={{ width: 300, ml: 1 }}
                  inputValue={colourNameForNewMapping}
                  onInputChange={(event, newInputValue) => {
                    setColourNameForNewMapping(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        !isEnglish ? `${langName} Colour Name` : `${langName} Swatch Colour Name`
                      }
                      variant="outlined"
                    />
                  )}
                />
                <Typography className="ml-3" sx={{ width: 300, color: 'secondary', fontSize: 9 }}> * Choose existing colour Or add new colour</Typography>
              </div>
            )
            : (
              <div className="flex flex-col -mt-5">
                <Autocomplete
                  size="large"
                  disablePortal
                  freeSolo
                  options={isEnglish ? englishSwatchColours : mainNonEnglishColours}
                  sx={{ width: 300, ml: 1 }}
                  inputValue={colourNameForNewMapping}
                  onInputChange={(event, newInputValue) => {
                    setColourNameForNewMapping(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={!isEnglish ? `${langName} Colour Name` : `${langName} Swatch Colour Name`}
                      variant="outlined"
                    />
                  )}
                />
                <Typography className="ml-3" sx={{ width: 300, color: 'secondary', fontSize: 9 }}> * Choose existing colour Or add new colour</Typography>
                <div className="flex flex-col mt-2">
                  <Autocomplete
                    size="large"
                    disablePortal
                    options={isEnglish ? mainColours : englishSwatchColours}
                    sx={{ width: 300, ml: 1, mb: 2 }}
                    inputValue={selectedColourNameForNewMapping}
                    onInputChange={(event, newInputValue) => {
                      setSelectedColourNameForNewMapping(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={!isEnglish
                          ? 'Swatch Colours' : 'Main Colours'}
                        variant="outlined"
                      />
                    )}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </Modal>
  );
}

export default NewMapping;
